import React from "react";
import classes from "./storeCheckoutLocatorModal.css";
import logoStokes from '@magento/venia-ui/venia-static/images/logostokes.png';
import logoThinkKitchen from '@magento/venia-ui/venia-static/icons/thinkkitchen.svg';
var StokesThinkkithenContainer = props => {
  var {
    is_thinkkitchen,
    name,
    imageWidth = '100px'
  } = props;
  return /*#__PURE__*/React.createElement("div", null, is_thinkkitchen === "1" ? /*#__PURE__*/React.createElement("img", {
    className: classes.thinkkitchen,
    src: logoThinkKitchen,
    alt: name,
    width: imageWidth
  }) : /*#__PURE__*/React.createElement("img", {
    src: logoStokes,
    alt: name,
    width: imageWidth
  }));
};
export default StokesThinkkithenContainer;